export const normalizeBranchId = (value) => {
  if (value === undefined || value === null || value === "") return null;
  return String(value);
};

export const isTruthyFlag = (value) =>
  value === true || value === 1 || value === "1" || value === "true";

export const getEntityBranchId = (entity) => {
  if (!entity) return null;

  return (
    entity.branch_id ??
    entity.branchId ??
    entity.branch?.id ??
    entity.branch?.branch_id ??
    entity.branch?.branchId ??
    entity.branch?.value ??
    null
  );
};

export const getOrderBranchId = (order, fallbackBranchId = null) =>
  normalizeBranchId(getEntityBranchId(order)) ||
  normalizeBranchId(fallbackBranchId);

export const isSameBranch = (sourceBranchId, targetBranchId) => {
  const source = normalizeBranchId(sourceBranchId);
  const target = normalizeBranchId(targetBranchId);

  return !!source && !!target && source === target;
};

export const isEntityInBranch = (entity, branchId) =>
  isSameBranch(getEntityBranchId(entity), branchId);

export const isBranchScopedWaiter = (employee, branchId) =>
  isTruthyFlag(employee?.is_waiter) && isEntityInBranch(employee, branchId);
